<script>
  import { onMount } from 'svelte'
  import axios from 'axios'

  import OverlayDonut from './OverlayDonut.svelte'

  import { runPromises, ordinalSuffix } from '../util/utils'

  const getRateProvider = ()=> axios('https://webcentral.uc.edu/scorecard/_json/rateprovider.cfm')

  const promises = {
    rateProvider: getRateProvider
  }

  let results = undefined
  let value = 0
  let percentile = undefined
  let small = false

  onMount(async ()=>{
    results = await runPromises(promises)

    if(results && !results.rateProvider.error) {
      let values = Object.values(results.rateProvider.data.data)
      value = values[0]
      percentile = values[1]
    }
  })
</script>

<div class="press-ganey">
  { #if results && !results.rateProvider.error }
    <OverlayDonut { value }>
      { #if percentile }
        <p class="percentile">{ ordinalSuffix(percentile) } percentile</p>
        <img src="https://www.med.uc.edu/images/default-source/facts-and-figures/press-ganey-logo-pink.png" alt="PressGaney logo" />
      { /if }
    </OverlayDonut>
  { :else }
    <p>loading...</p>
  { /if }
</div>

<style>
  p.percentile {
    color: var(--uc-red);
    padding: 0;
    margin: 0;
  }

  img {
    max-width: 100%;
  }
</style>